import { render, staticRenderFns } from "./DocumentsEditForm.vue?vue&type=template&id=24bfbf05&scoped=true"
import script from "./DocumentsEditForm.vue?vue&type=script&lang=js"
export * from "./DocumentsEditForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentsEditForm.vue?vue&type=style&index=0&id=24bfbf05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bfbf05",
  null
  
)

export default component.exports